// @flow

import React from 'react';
import styled from 'styled-components';

import CtaLink from 'components/shared/cta-link';

import { CLARK_SECONDARY } from 'styles/colors';
import { TYPE_SCALE_F5 } from 'styles/type-scale';
import { SPACING_SMALL, SPACING_LARGE } from 'styles/spacing';

const CopyLink = ({ className, copy, linkCopy, link, openInNewTab = false }: any) => (
  <Container>
    {copy && <Copy className={className}>{copy}</Copy>}
    <CtaLink className={className} to={link} target={openInNewTab ? '_blank' : '_self'}>
      {linkCopy}
    </CtaLink>
  </Container>
);

export default CopyLink;

const Container = styled.span`
  display: block;
  margin: ${SPACING_SMALL} 0 ${SPACING_LARGE} 0;
`;

const Copy = styled.p`
  ${TYPE_SCALE_F5};
  color: ${CLARK_SECONDARY};
  display: inline-block;
  margin-right: ${SPACING_SMALL};
`;



// WEBPACK FOOTER //
// ./src/components/shared/copy-link/index.js